import { CuratedCategoryModel } from './curated-category.model';
import { GuideModel } from './guide.model';
import { ILocalityModel } from './locality.model';
import { PlaceModel } from './place.model';

export enum BreadcrumbType {
  Destination,
  Guides,
  Guide,
  Category,
  Place,
}

export interface IBreadcrumbModel {
  type?: BreadcrumbType;
  title?: string;
  category?: CuratedCategoryModel;
  place?: PlaceModel;
  locality?: ILocalityModel;
  guide?: GuideModel;
}
